var _defs, _rect, _rect2, _rect3, _rect4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeCustomization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 400",
    role: "img",
    "aria-label": "A Kinetic form being customized, linked to a BPM workflow",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d1a28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123049"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sun",
    cx: 0.08,
    cy: 1,
    r: 0.85
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4a582",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4a582",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sky",
    cx: 0.95,
    cy: 0,
    r: 0.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fb6e3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fb6e3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 30,
    height: 30,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V30",
    fill: "none",
    stroke: "#4fb6e3",
    strokeOpacity: 0.07
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "btn",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f7fb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9735a"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L10 5L0 10z",
    fill: "#4fb6e3"
  })), /*#__PURE__*/React.createElement("style", null, "\n      .flow { stroke-dasharray: 5 5; animation: flow 1.2s linear infinite; }\n      .gear { transform-origin: 350px 58px; animation: spin 10s linear infinite; }\n      @keyframes flow { to { stroke-dashoffset: -20; } }\n      @keyframes spin { to { transform: rotate(360deg); } }\n      @media (prefers-reduced-motion: reduce) { .flow, .gear { animation: none; } }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#grid)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#sun)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#sky)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "'Segoe UI','Helvetica Neue',Arial,sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 58,
    width: 310,
    height: 290,
    rx: 12,
    fill: "#0f2233",
    stroke: "#4fb6e3",
    strokeOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 92V70a12 12 0 0 1 12-12h286a12 12 0 0 1 12 12v22z",
    fill: "#16324a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 75,
    r: 4.5,
    fill: "#f0926e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 4.5,
    fill: "#f4c58f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 75,
    r: 4.5,
    fill: "#4fb6e3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 80,
    fontSize: 13,
    fontWeight: 600,
    fill: "#b9c8d6"
  }, "Sales Order Entry"), /*#__PURE__*/React.createElement("g", {
    fontSize: 11.5,
    fill: "#8aa3b8"
  }, /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 117
  }, "Customer"), /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 117
  }, "PO Number"), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 171
  }, "Ship Via"), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 225
  }, "Rush"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 225
  }, "Lead Time (UD)")), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 123,
    width: 130,
    height: 26,
    rx: 5,
    fill: "#0d1a28",
    stroke: "#4fb6e3",
    strokeOpacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 134,
    width: 70,
    height: 5,
    rx: 2.5,
    fill: "#4fb6e3",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 123,
    width: 125,
    height: 26,
    rx: 5,
    fill: "#0d1a28",
    stroke: "#4fb6e3",
    strokeOpacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 134,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#4fb6e3",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 177,
    width: 270,
    height: 26,
    rx: 5,
    fill: "#0d1a28",
    stroke: "#f0926e",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 188,
    width: 90,
    height: 5,
    rx: 2.5,
    fill: "#f4a582",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f0926e"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 173,
    width: 8,
    height: 8,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 173,
    width: 8,
    height: 8,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 199,
    width: 8,
    height: 8,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 199,
    width: 8,
    height: 8,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 232,
    width: 46,
    height: 24,
    rx: 12,
    fill: "#f0926e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 244,
    r: 9,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 232,
    width: 200,
    height: 26,
    rx: 5,
    fill: "none",
    stroke: "#f4a582",
    strokeWidth: 1.5,
    strokeDasharray: "5 4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 143,
    y: 249,
    fontSize: 12,
    fontWeight: 600,
    fill: "#f4a582"
  }, "+ Add UD field"), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 292,
    width: 110,
    height: 34,
    rx: 8,
    fill: "none",
    stroke: "#4fb6e3",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 314,
    fontSize: 13,
    fontWeight: 600,
    fill: "#b9c8d6",
    textAnchor: "middle"
  }, "Cancel"), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 292,
    width: 110,
    height: 34,
    rx: 8,
    fill: "url(#btn)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 275,
    y: 314,
    fontSize: 13,
    fontWeight: 700,
    fill: "#ffffff",
    textAnchor: "middle"
  }, "Save"), /*#__PURE__*/React.createElement("path", {
    d: "M300 192v24l6-6l5 11l5-2l-5-11h9z",
    fill: "#ffffff",
    stroke: "#0d1a28",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 58,
    r: 27,
    fill: "#f0926e"
  }), /*#__PURE__*/React.createElement("g", {
    className: "gear"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 58,
    r: 15.5,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 6,
    strokeDasharray: "6.2 6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 58,
    r: 13,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 58,
    r: 5,
    fill: "#f0926e"
  })), /*#__PURE__*/React.createElement("path", {
    className: "flow",
    d: "M334 190C385 190 380 248 413 248",
    fill: "none",
    stroke: "#f0926e",
    strokeOpacity: 0.8,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 74,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 1.5,
    fill: "#8aa3b8",
    textAnchor: "middle"
  }, "BPM WORKFLOW"), /*#__PURE__*/React.createElement("g", {
    fontSize: 12,
    fontWeight: 600,
    fill: "#e8eaf0",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 413,
    y: 86,
    width: 134,
    height: 34,
    rx: 17,
    fill: "#0f2233",
    stroke: "#4fb6e3",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 107
  }, "SalesOrder.Update"), /*#__PURE__*/React.createElement("path", {
    d: "M480 146l32 30l-32 30l-32-30z",
    fill: "#0f2233",
    stroke: "#f4a582"
  }), /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 180
  }, "Rush?"), /*#__PURE__*/React.createElement("rect", {
    x: 413,
    y: 232,
    width: 134,
    height: 34,
    rx: 8,
    fill: "#0f2233",
    stroke: "#f0926e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 253
  }, "Set Ship Via"), /*#__PURE__*/React.createElement("rect", {
    x: 413,
    y: 292,
    width: 134,
    height: 34,
    rx: 8,
    fill: "#0f2233",
    stroke: "#4fb6e3",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 313
  }, "Email Planner")), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#4fb6e3",
    strokeOpacity: 0.75,
    strokeWidth: 1.5,
    markerEnd: "url(#arrow)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "flow",
    d: "M480 120V143"
  }), /*#__PURE__*/React.createElement("path", {
    className: "flow",
    d: "M480 206V229"
  }), /*#__PURE__*/React.createElement("path", {
    className: "flow",
    d: "M480 266V289"
  })), /*#__PURE__*/React.createElement("text", {
    x: 488,
    y: 222,
    fontSize: 11,
    fontWeight: 700,
    fill: "#f4a582"
  }, "YES"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCustomization);
export default __webpack_public_path__ + "static/media/home-customization.1888dc79bdcf029374ba8e9be3a94423.svg";
export { ForwardRef as ReactComponent };